export const AppActionType = {
  LOGOUT: 'logout',
};

export const sendMessageToApp = message => {
  window.AppChannel && window.AppChannel.postMessage(JSON.stringify(message));
};
